import { render, staticRenderFns } from "./JelentkezesAdatok.vue?vue&type=template&id=31577753&"
import script from "./JelentkezesAdatok.vue?vue&type=script&lang=ts&"
export * from "./JelentkezesAdatok.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports